@if (!isHidden) {
    @let tooltip = slot() | slotTooltip; @let title = slot().titleKey | translationKey: slot().titleData;
    <div class="flex items-start">
        <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            floatLabel="always"
            class="ca-form-field ca-form-field-m ca-form-field-w-full with-label with-error-message"
        >
            @if (title) {
                <mat-label>{{ title }}</mat-label>
            }
            <input
                matInput
                (input)="onValueChange(control.value)"
                [formControl]="control"
                [placeholder]="(slot().placeholderKey | translationKey: slot().placeholderData) || ''"
                [disabled]="!!isDisabled"
                [mask]="mask.pattern"
                [patterns]="mask.customPatterns!"
                [decimalMarker]="mask.decimalMarker!"
                [separatorLimit]="mask.separatorLimit!"
                [dropSpecialCharacters]="mask.dropSpecialCharacters!"
                [suffix]="(slot().suffixKey | translationKey: slot().suffixData) || '' | addSpace: 'start'"
                [prefix]="(slot().prefixKey | translationKey: slot().prefixData) || '' | addSpace: 'end'"
                [required]="!slot().isOptional"
            />
            @if (isErrorMessage) {
                <mat-error>
                    <ca-form-error-message>
                        {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                    </ca-form-error-message>
                </mat-error>
            }
        </mat-form-field>
        @if (isVisual && !tooltip) {
            <div class="flex items-center ms-2 py-9">
                <ca-visual [slot]="slot()" [iconSize]="24"></ca-visual>
            </div>
        } @else if (tooltip) {
            <div class="flex items-center ms-2 py-9">
                <ca-visual [tooltip]="tooltip"></ca-visual>
            </div>
        }
    </div>
}
